import React from "react";

const Editorial: React.FunctionComponent<any> = ({ html }) => {
  return (
    <div className="Editorial" dangerouslySetInnerHTML={{__html: html}} />
  )
}

export default Editorial;
